export class LoanPipelinesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanPipelines(params) {
    return this.#http.get('/api/loanPipelines', { params });
  }

  async getLoanPipelinesColumnDefinitions() {
    return this.#http.get('/api/loanPipelines/columnDefinitions');
  }

  async getLoanPipelinesDynamicView({ loanPipelineId, signal, ...body }) {
    return this.#http.post(`/api/loanPipelines/${loanPipelineId}/dynamicViewData `, body, {
      signal,
    });
  }

  async createLoanPipeline(body) {
    return this.#http.post('/api/loanPipelines', body);
  }

  async editLoanPipeline(body) {
    return this.#http.put(`/api/loanPipelines/${body.id}`, body);
  }

  async editLoanPipelinesOrder(body) {
    return this.#http.put(`/api/loanPipelines`, body);
  }

  async getKanbanViewData({ loanPipelineId, searchInput, columnFilters }) {
    return this.#http.post(`/api/loanPipelines/${loanPipelineId}/kanbanViewData`, {
      searchInput: searchInput || null,
      columnFilters: columnFilters?.length ? columnFilters : null,
    });
  }

  async getPipelineStats({ loanPipelineId }) {
    return this.#http.get(`/api/loanPipelines/${loanPipelineId}/stats`);
  }

  async deleteLoanPipeline({ id }) {
    return this.#http.delete(`/api/loanPipelines/${id}`);
  }
}
